import "./base.css";

import "./comments/mod.js";
import "./nav-main/mod.js";

document.querySelector("html").classList.remove("no-js");
